import {ClientHistoryEventTypes} from '@/types'
import {getClosestCommentToToday} from '@/utils/comments'

export function mapLeadToClientHistory(data: any) {
  return {
    ...data,
    event: ClientHistoryEventTypes.LEAD,
    createDate: data.createdAt,
    followUp: getClosestCommentToToday(data.commentLog),
    attendedBy: data.assignee?.agent || '',
  }
}
